import { TranslationMap } from '@trimble-gcs/i18n-types';

export function connectFileBrowserTableTranslations() {
  return {
    columnHeaders: {
      name: {
        text: $localize`:@@import.dialog.picker.connect.columnHeaders.name:Name`,
        desc: 'Column header for the file name column.',
      },
      modifiedBy: {
        text: $localize`:@@import.dialog.picker.connect.columnHeaders.modifiedBy:Modified By`,
        desc: 'Column header for the file modified by column.',
      },
      modifiedOn: {
        text: $localize`:@@import.dialog.picker.connect.columnHeaders.modifiedOn:Modified On`,
        desc: 'Column header for the file modified date column.',
      },
      size: {
        text: $localize`:@@import.dialog.picker.connect.columnHeaders.size:Size`,
        desc: 'Column header for the file size column.',
      },
    },
  } satisfies TranslationMap;
}
